var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile==false)?_c('Header',{attrs:{"nowActive":_vm.nowActive}}):_vm._e(),(_vm.isMobile==false)?_c('PublicBanner'):_vm._e(),_vm._m(0),(_vm.isMobile==false)?_c('Publicfooter',{ref:"footer"}):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../assets/img/businessScenario.jpg")}})])
}]

export { render, staticRenderFns }